import { useMutation, useQueryClient } from '@tanstack/react-query';
import { endpointOidcUserQueryKeys, hostQueryKeys, Hosts } from '#api';

/** Used to delete lighthouses and hosts */
export function useDeleteHostMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (hostId: string) => Hosts.deleteHost(hostId),
    onSuccess: (data, hostId) => {
      // Prefix match: effective access and dnclient command results are keyed under the detail
      // key, and a deleted host should not leave those behind either.
      queryClient.removeQueries({ queryKey: hostQueryKeys.detail(hostId) });
      void queryClient.invalidateQueries({ queryKey: hostQueryKeys.lists() });
      // The API deletes an endpoint OIDC user along with their last host.
      void queryClient.invalidateQueries({ queryKey: endpointOidcUserQueryKeys.lists() });
    },
  });
}
